import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { A2PRegistrationService } from '../a2p-registration.service';
import { RegistrationStage } from '../a2p-registration.constants';
import { LearnMoreModalComponent } from '../info-banner/learn-more-modal/learn-more-modal.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'sms-registration-error-banner',
  templateUrl: './sms-registration-error-banner.component.html',
  styleUrls: ['./sms-registration-error-banner.component.scss'],
  standalone: false,
})
export class SmsRegistrationErrorBannerComponent implements OnInit {
  registrationStage$: Observable<RegistrationStage>;

  protected readonly RegistrationStage = RegistrationStage;

  constructor(
    private smsRegistrationService: A2PRegistrationService,
    private dialog: MatDialog,
  ) {}

  ngOnInit() {
    this.registrationStage$ = this.smsRegistrationService.registrationStage$;
  }
  openLearnMoreModal(): void {
    this.dialog.open(LearnMoreModalComponent, { width: '600px' });
  }
}
